<template>
  <div
    class="vibration-container"
    dir="rtl"
  >
    <!-- Header -->
    <div class="header">
      <div class="header-content">
        <div class="header-main">
          <h2>🔔 تنظیمات هشدار لرزشی</h2>
          <p>تنظیم حساسیت سنسور ضربه و مدیریت هشدارهای لرزشی</p>
        </div>
        <button
          class="help-toggle"
          @click="helpOpen = !helpOpen"
        >
          <span class="help-text">راهنما</span>
          <span class="help-arrow">{{ helpOpen ? '▼' : '◀' }}</span>
        </button>
      </div>

      <!-- Help Content -->
      <div
        v-if="helpOpen"
        class="help-content"
      >
        <div class="help-item">
          <p>🎯 <strong>حساسیت سنسور:</strong> سطح 1 (کم‌حساس) تا 5 (پرحساس) برای تشخیص ضربه</p>
        </div>
        <div class="help-item">
          <p>📱 <strong>نحوه ارسال هشدار:</strong> روش دریافت اطلاع‌رسانی (اپلیکیشن، پیامک یا تماس)</p>
        </div>
        <div class="help-item">
          <p>⚡ <strong>هشدار فوری:</strong> در صورت ضربه به خودرو فوراً اطلاع داده می‌شود</p>
        </div>
        <div class="help-item">
          <p>🔧 <strong>توضیح:</strong> ابتدا حساسیت و نحوه ارسال را انتخاب کنید، سپس هشدار را فعال کنید</p>
        </div>
      </div>
    </div>

    <!-- Loading indicator -->
    <div
      v-if="isLoadingData"
      class="loading-section"
    >
      <div class="loading-spinner">
        ⏳
      </div>
      <p>در حال بارگذاری تنظیمات...</p>
    </div>

    <!-- Settings Section -->
    <div
      v-else
      class="settings-section"
    >
      <!-- Current Status - Compact -->
      <div class="status-compact">
        <div class="status-info">
          <span class="status-label">وضعیت فعلی:</span>
          <div class="status-badge-container">
            <span :class="['status-badge', isVibrationEnabled ? 'active' : 'inactive']">
              <span class="status-icon">{{ isVibrationEnabled ? '🔔' : '🔕' }}</span>
              <span class="status-text">{{ isVibrationEnabled ? 'فعال' : 'غیرفعال' }}</span>
            </span>
            <span
              v-if="isVibrationEnabled"
              class="status-details"
            >
              {{ getCurrentSensitivityText() }} | {{ getSelectedMethodName() }}
            </span>
          </div>
        </div>
      </div>

      <!-- Alert Method and Enable (MOVED TO FIRST) -->
      <div class="setting-card compact">
        <div class="card-box-header">
          <span class="card-icon">📢</span>
          <h3>روش اطلاع‌رسانی و فعال‌سازی</h3>
        </div>
        <div class="card-content">
          <div class="alert-method-selector">
            <label class="input-label">روش دریافت هشدار:</label>
            <div class="method-list">
              <div
                v-for="method in alertMethods"
                :key="method.value"
                :class="['method-option', { 'selected': alertMethod === method.value }]"
                @click="alertMethod = method.value"
              >
                <div class="method-radio">
                  <div :class="['radio-circle', { 'checked': alertMethod === method.value }]">
                    <div
                      v-if="alertMethod === method.value"
                      class="radio-dot"
                    />
                  </div>
                </div>
                <div class="method-content">
                  <div class="method-header">
                    <span class="method-icon">{{ method.icon }}</span>
                    <span class="method-name">{{ method.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button
            class="btn btn-success btn-compact full-width"
            :disabled="isLoading"
            @click="enableVibrationAlert"
          >
            <span v-if="!isLoading">✅ فعال‌سازی با {{ getSelectedMethodName() }}</span>
            <span v-else>⏳ در حال فعال‌سازی...</span>
          </button>
        </div>
      </div>

      <!-- Sensitivity Settings (MOVED TO SECOND) -->
      <div class="setting-card compact">
        <div class="card-box-header">
          <span class="card-icon">🎯</span>
          <h3>تنظیم حساسیت سنسور</h3>
        </div>
        <div class="card-content">
          <div class="sensitivity-selector">
            <div class="sensitivity-grid">
              <div
                v-for="level in sensitivityLevels"
                :key="level.value"
                :class="['sensitivity-item', { 'selected': selectLevel === level.value }]"
                @click="selectLevel = level.value"
              >
                <div class="level-number">
                  {{ level.value }}
                </div>
                <div class="level-text">
                  {{ level.text }}
                </div>
              </div>
            </div>
          </div>

          <button
            class="btn btn-primary btn-compact"
            :disabled="isLoading || !selectLevel"
            @click="setSensitivity"
          >
            <span v-if="!isLoading">🎯 تنظیم حساسیت</span>
            <span v-else>⏳ در حال ارسال...</span>
          </button>
        </div>
      </div>

      <!-- Disable Section -->
      <div class="setting-card compact danger-card">
        <div class="card-box-header danger-header">
          <span class="card-icon">🔕</span>
          <h3>خاموش کردن هشدار</h3>
        </div>

        <div class="card-content">
          <div class="warning-text">
            <p>⚠️ با خاموش کردن هشدار، در صورت ضربه به خودرو اطلاع‌رسانی نخواهید داشت.</p>
          </div>

          <button
            class="btn btn-danger btn-compact full-width"
            :disabled="isLoading || !isVibrationEnabled"
            @click="disableVibrationAlert"
          >
            <span v-if="!isLoading">❌ خاموش کردن هشدار لرزشی</span>
            <span v-else">⏳ در حال خاموش کردن...</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import axios from 'axios'
import authHeader from '@/services/auth-header'

export default {
  name: 'VibrationAlertSettings',
  props: {
    selectedImei: {
      type: String,
      required: true,
    },
    deviceInfo: {
      type: Object,
      required: false,
      default: () => null,
    },
  },
  data() {
    return {
      selectLevel: '3',
      alertMethod: '1',
      isLoading: false,
      isLoadingData: false,
      helpOpen: false,
      isVibrationEnabled: false,
      currentSensitivity: '3',

      sensitivityLevels: [
        { value: '1', text: 'خیلی کم', description: 'فقط ضربات شدید' },
        { value: '2', text: 'کم', description: 'ضربات متوسط به بالا' },
        { value: '3', text: 'متوسط', description: 'توصیه شده' },
        { value: '4', text: 'زیاد', description: 'حساسیت بالا' },
        { value: '5', text: 'خیلی زیاد', description: 'حساس‌ترین سطح' },
      ],

      alertMethods: [
        {
          value: '0',
          name: 'فقط اپلیکیشن',
          icon: '📱',
        },
        {
          value: '1',
          name: 'اپلیکیشن + پیامک',
          icon: '📱💬',
        },
        {
          value: '2',
          name: 'همه روش‌ها',
          icon: '📱💬📞',
        },
      ],
    }
  },
  watch: {
    selectedImei: {
      handler(newVal) {
        if (newVal) {
          this.loadSettings()
        }
      },
      immediate: true,
    },
  },
  methods: {
    async loadSettings() {
      if (!this.selectedImei) return

      this.isLoadingData = true
      try {
        await this.loadVibrationSettings()
      } catch (error) {
        this.showToast('خطا در بارگذاری تنظیمات', 'error')
      } finally {
        this.isLoadingData = false
      }
    },

    async loadVibrationSettings() {
      try {
        const response = await this.apiGetDeviceSettings(this.selectedImei)

        if (response.status === 'success' && response.result && response.result.data) {
          const deviceData = response.result.data
          const settings = deviceData.alertSettings || {}
          const vibrationSettings = deviceData.vibrationSettings || {}

          // Check both alertSettings.vibrationAlert AND vibrationSettings.isEnabled
          this.isVibrationEnabled = (settings.vibrationAlert && vibrationSettings.isEnabled) || false
          this.currentSensitivity = vibrationSettings.sensitivity || '3'
          this.selectLevel = this.currentSensitivity
          this.alertMethod = vibrationSettings.alertMethod || '1'
        }
      } catch (error) {
        // در صورت خطا، مقادیر پیش‌فرض
        this.isVibrationEnabled = false
        this.currentSensitivity = '3'
        this.selectLevel = '3'
        this.alertMethod = '1'
      }
    },

    async setSensitivity() {
      if (!this.selectLevel) {
        this.showToast('لطفا سطح حساسیت را انتخاب کنید', 'warning')
        return
      }

      this.isLoading = true
      try {
        const command = `LEVEL,${this.selectLevel}#`
        const response = await this.apiSendCommand(this.selectedImei, command)

        if (response.status === 'success') {
          this.currentSensitivity = this.selectLevel
          this.showToast(`حساسیت سنسور به سطح ${this.selectLevel} تنظیم شد! 🎯`, 'success')
          this.$emit('command-sent', { command, success: true })
        }
      } catch (error) {
        this.showToast('خطا در تنظیم حساسیت', 'error')
        this.$emit('command-sent', { command: '', success: false, error })
      } finally {
        this.isLoading = false
      }
    },

    async enableVibrationAlert() {
      this.isLoading = true
      try {
        const command = `SENALM,ON,${this.alertMethod}#`
        const response = await this.apiSendCommand(this.selectedImei, command)

        if (response.status === 'success') {
          this.isVibrationEnabled = true
          this.showToast(`هشدار لرزشی با ${this.getSelectedMethodName()} فعال شد! ✅`, 'success')
          this.$emit('command-sent', { command, success: true })
        }
      } catch (error) {
        this.showToast('خطا در فعال‌سازی هشدار', 'error')
        this.$emit('command-sent', { command: '', success: false, error })
      } finally {
        this.isLoading = false
      }
    },

    async disableVibrationAlert() {
      this.isLoading = true
      try {
        const command = 'SENALM,OFF#'
        const response = await this.apiSendCommand(this.selectedImei, command)

        if (response.status === 'success') {
          this.isVibrationEnabled = false
          this.showToast('هشدار لرزشی غیرفعال شد ❌', 'success')
          this.$emit('command-sent', { command, success: true })
        }
      } catch (error) {
        this.showToast('خطا در غیرفعال‌سازی هشدار', 'error')
        this.$emit('command-sent', { command: '', success: false, error })
      } finally {
        this.isLoading = false
      }
    },

    getSelectedMethodName() {
      const method = this.alertMethods.find(m => m.value === this.alertMethod)
      return method ? method.name : 'روش انتخابی'
    },

    getCurrentSensitivityText() {
      const level = this.sensitivityLevels.find(l => l.value === this.currentSensitivity)
      return level ? level.text : 'متوسط'
    },

    // API Methods
    async apiGetDeviceSettings(imei) {
      try {
        let API_URL
        if (localStorage.getItem('gpsServers')) {
          API_URL = JSON.parse(localStorage.getItem('gpsServers')).server1.url
        } else {
          API_URL = Vue.prototype.$gpsServers?.server1?.url || 'https://s1.4-rah.com'
        }

        const response = await axios.post(
          `${API_URL}/device/status-and-settings`,
          { imei },
          { headers: authHeader() },
        )
        return response.data
      } catch (error) {
        this.handleApiError(error)
        throw error
      }
    },

    async apiSendCommand(imei, commandName) {
      try {
        let API_URL
        if (localStorage.getItem('gpsServers')) {
          API_URL = JSON.parse(localStorage.getItem('gpsServers')).server1.url
        } else {
          API_URL = Vue.prototype.$gpsServers?.server1?.url || 'https://s1.4-rah.com'
        }

        const response = await axios.post(
          `${API_URL}/device/command`,
          { imei, commandName },
          { headers: authHeader() },
        )
        return response.data
      } catch (error) {
        this.handleApiError(error)
        throw error
      }
    },

    handleApiError(error) {
      let message = 'خطای غیرمنتظره رخ داد'

      if (error.response) {
        switch (error.response.status) {
          case 401:
            message = 'عدم احراز هویت. لطفا دوباره وارد شوید'
            break
          case 403:
            message = 'شما مجوز دسترسی به این بخش را ندارید'
            break
          case 404:
            message = 'دستگاه یافت نشد'
            break
          case 500:
            message = 'خطای سرور. لطفا بعداً تلاش کنید'
            break
          default:
            message = error.response.data?.message || 'خطا در ارتباط با سرور'
        }
      } else if (error.request) {
        message = 'عدم ارتباط با سرور. اتصال اینترنت را بررسی کنید'
      }

      this.showToast(message, 'error')
    },

    showToast(message, type = 'info') {
      const variants = {
        success: 'success',
        error: 'danger',
        warning: 'warning',
        info: 'info',
      }

      const icons = {
        success: 'CheckIcon',
        error: 'XIcon',
        warning: 'AlertTriangleIcon',
        info: 'InfoIcon',
      }

      const titles = {
        success: 'موفقیت',
        error: 'خطا',
        warning: 'هشدار',
        info: 'اطلاع',
      }

      try {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: titles[type] || 'اطلاع',
            text: message,
            icon: icons[type] || 'InfoIcon',
            variant: variants[type] || 'info',
          },
        })
      } catch (error) {
        alert(`${titles[type]}: ${message}`)
      }
    },
  },
}
</script>

<style scoped>
.vibration-container {
  padding: 16px;
  max-width: 800px;
  margin: 0 auto;
  font-family: 'Vazir', sans-serif;
}

.header {
  background: #ffffff;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  color: #374151;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.header-main h2 {
  margin: 0 0 8px 0;
  font-size: 1.4rem;
  font-weight: 600;
  color: #1f2937;
}

.header-main p {
  margin: 0;
  font-size: 0.9rem;
  color: #6b7280;
}

.help-toggle {
  background: #f9fafb;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 6px 12px;
  color: #374151;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.help-toggle:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.help-content {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  margin-top: 12px;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.help-item {
  margin-bottom: 12px;
}

.help-item:last-child {
  margin-bottom: 0;
}

.help-item p {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.4;
}

/* Compact Status Styles */
.status-compact {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.status-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.status-label {
  font-weight: 500;
  color: #495057;
  font-size: 0.9rem;
  white-space: nowrap;
}

.status-badge-container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.status-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 0.85rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.status-badge.active {
  background: #10b981;
  color: white;
  border: none;
}

.status-badge.inactive {
  background: #ef4444;
  color: white;
  border: none;
}

.status-icon {
  font-size: 1rem;
}

.status-text {
  font-weight: 600;
}

.status-details {
  font-size: 0.8rem;
  color: #6b7280;
  background: #f9fafb;
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.loading-section {
  text-align: center;
  padding: 40px 20px;
  background: #f8f9fa;
  border-radius: 12px;
}

.loading-spinner {
  font-size: 2rem;
  margin-bottom: 16px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.setting-card, .control-section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.setting-card.compact, .control-section.compact {
  margin-bottom: 12px;
}

.setting-card.danger-card {
  border: 1px solid #fecaca;
  background: #ffffff;
}

.card-box-header, .control-header {
  background: #374151;
  color: white;
  padding: 12px 16px;
  display: flex;
  align-items: center;
}

.danger-header {
  background: #dc2626;
}

.card-box-header h3, .control-header h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
}

[dir=rtl] .card-box-header h3{
  padding-right: 5px;
}

.card-icon, .control-icon {
  font-size: 1.1rem;
}

.card-content, .control-content {
  padding: 16px;
}

.warning-text {
  background: #fef3c7;
  border: 1px solid #f59e0b;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 16px;
}

.warning-text p {
  margin: 0;
  color: #856404;
  font-size: 0.9rem;
  line-height: 1.4;
}

.full-width {
  width: 100%;
}

.description {
  color: #666;
  margin-bottom: 16px;
  line-height: 1.5;
  font-size: 0.9rem;
}

.input-label {
  display: block;
  font-weight: 500;
  margin-bottom: 10px;
  color: #333;
  font-size: 0.9rem;
}

.sensitivity-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  gap: 8px;
  margin-bottom: 16px;
}

.sensitivity-item {
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 12px 8px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sensitivity-item:hover {
  border-color: #007bff;
  transform: translateY(-1px);
}

.sensitivity-item.selected {
  border-color: #007bff;
  background: #e7f3ff;
}

.level-number {
  font-size: 1.3rem;
  font-weight: bold;
  color: #007bff;
  margin-bottom: 2px;
}

.level-text {
  font-weight: 500;
  color: #333;
  font-size: 0.8rem;
}

.level-desc {
  font-size: 0.7rem;
  color: #666;
}

/* New Alert Method Styles */
.method-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.method-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.method-option:hover {
  border-color: #007bff;
  background: #f8f9ff;
}

.method-option.selected {
  border-color: #007bff;
  background: #e7f3ff;
}

.method-radio {
  flex-shrink: 0;
}

.radio-circle {
  width: 18px;
  height: 18px;
  border: 2px solid #ddd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.radio-circle.checked {
  border-color: #007bff;
}

.radio-dot {
  width: 8px;
  height: 8px;
  background: #007bff;
  border-radius: 50%;
}

.method-content {
  flex: 1;
}

.method-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.method-icon {
  font-size: 1rem;
}

.method-name {
  font-weight: 500;
  color: #333;
  font-size: 0.9rem;
}

.method-desc {
  font-size: 0.75rem;
  color: #666;
  line-height: 1.3;
  margin-top: 2px;
}

/* Control Section Styles */
.current-status {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  margin-bottom: 12px;
}

.status-indicator {
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 0.8rem;
  font-weight: bold;
}

.status-indicator.enabled {
  background: #d4edda;
  color: #155724;
}

.status-indicator.disabled {
  background: #f8d7da;
  color: #721c24;
}

.control-description {
  margin-bottom: 16px;
}

.control-description p {
  color: #666;
  line-height: 1.5;
  margin: 0;
  font-size: 0.9rem;
}

.control-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.btn {
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.btn.btn-compact {
  padding: 8px 14px;
  font-size: 0.85rem;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background: #3b82f6;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #2563eb;
}

.btn-success {
  background: #10b981;
  color: white;
}

.btn-success:hover:not(:disabled) {
  background: #059669;
}

.btn-danger {
  background: #ef4444;
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background: #dc2626;
}

@media (max-width: 768px) {
  .vibration-container {
    padding: 12px;
  }

  .header {
    padding: 16px;
  }

  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .header-main h2 {
    font-size: 1.2rem;
  }

  .header-main p {
    font-size: 0.85rem;
  }

  .status-compact {
    padding: 12px;
  }

  .status-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .status-badge-container {
    width: 100%;
    justify-content: space-between;
  }

  .control-buttons {
    grid-template-columns: 1fr;
  }

  .sensitivity-grid {
    grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));
  }

  .method-option {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }

  .method-header {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .header {
    padding: 14px;
  }

  .header-main h2 {
    font-size: 1.1rem;
  }

  .status-compact {
    padding: 10px;
  }

  .status-badge {
    font-size: 0.8rem;
    padding: 4px 8px;
  }

  .status-details {
    font-size: 0.75rem;
    padding: 3px 6px;
  }

  .sensitivity-grid {
    grid-template-columns: repeat(5, 1fr);
    gap: 6px;
  }

  .sensitivity-item {
    padding: 8px 4px;
  }

  .level-number {
    font-size: 1.1rem;
  }

  .level-text {
    font-size: 0.7rem;
  }
}
</style>
